import React, { Component } from 'react';
import {connect} from 'react-redux';
import orderBy from 'lodash/orderBy';
import { Collapse } from 'react-bootstrap';
// import {getAgents} from '../actions/getAgentConfig';
import {doCall} from '../actions/call';
import AgentPanelRow from './AgentPanelRow';
import Loader from './Components/Loader';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";

class AgentPanel extends Component {
	constructor(props) {
    super(props);
    this.state = {
			open: true,
			allAgents: [],
			searchFilter: ''
		};
  }
	/**
	 * gets telephone availability of agent
	 * @param  {object} agent
	 * @return {object}       title and icon color
	 */
	getTelephoneAvailability = (agent) => {
		let availability = {
			title: '',
			iconColor: ''
		};
		if(agent.busy){
			availability.title = this.props.translations.onCall[this.props.selectedLanguage];
			availability.iconColor = 'user-busy';
		}
		if(!agent.busy && !agent.availability){
			availability.title = agent.reason || this.props.translations.unavailable[this.props.selectedLanguage];
			availability.iconColor = 'user-unavailable';
		}
		if(!agent.busy && agent.availability){
			availability.title = this.props.translations.available[this.props.selectedLanguage];
			availability.iconColor = 'user-available';
		}
		return availability;
	}

	// check for user availability. if available then makes call
    // Es posible que no se use nunca.
	handlePhoneClick = (e) => {
		const idArr = e.target.id.split('_');
		const type = idArr[0];
		const id = idArr[1];
		const { extension, availability, busy } = this.props[type].find(item => item.id == id);
		if(!busy){
			this.makeCall(extension);
		}
	}

	// makes outgoing call.
	makeCall = (phoneNumber) => {
		const payload = {
			phoneNumber,
			internalCall: true
		};
		this.props.doCall(payload);
	}

	handleSearchChange = (e) => {
    this.setState({
      searchFilter: e.target.value
    });
  }

	handleAgentWindow = (e) => {
		e.preventDefault();
		e.stopPropagation();
		window.open(`${window.location.href}?isAgentPage=true`, '_blank');
	}

	/**
	 * render list of agents or supervisors
	 * @param  {array} users
	 * @param  {string} type  agents or supervisors
	 */
	renderList = (users, type, isSupervisor) => {
		let sortedData = orderBy(users, [user => user.name ? user.name.toLowerCase() : ''], ['asc']);
			sortedData = orderBy(sortedData, 'availability', 'desc');
			sortedData = orderBy(sortedData, 'online', 'desc');
			sortedData = orderBy(sortedData, 'busy', 'desc');
		return (
		sortedData.filter(item => item.name &&
			(item.name.toLowerCase().includes(this.state.searchFilter.toLowerCase()) ||
			item.extension.includes(this.state.searchFilter))
		)
		.map(user => {
			if(this.props.agentInfo.agent_id!=user.id && user.is_supervisor == isSupervisor){
			return (
			<AgentPanelRow
				key={user.id}
				user={user}
				type={type}
			/>
			);
			}
		})
		)
	}
	render() {
		const {
			agents,
			agentsLoadComplete,
			agentInfo,
			translations,
			selectedLanguage
		} = this.props;
		return (
      <div className={`panel${this.props.theme} panel-default${this.props.theme}`}>
        <div className={`panel-heading panel-heading${this.props.theme}`}>
          <h3 className="panel-title">
            <a className="show btn-icon" onClick={ ()=> this.setState({ open: !this.state.open })}>
              <span className="icon icon-user icon-right-space" />
              <span className="anchor_text">{translations.agent[selectedLanguage]}</span>
              <span className="icon icon-select-arrows pull-right" />
							{agentInfo.supervisor && <span onClick={this.handleAgentWindow} className="icon icon-eye pull-right" style={{marginRight: 10}} />}
            </a>
          </h3>
        </div>
        <Collapse in={this.state.open}>
          <ul className="padding-0 margin-bottom-0">
            <ul className="list-group margin-bottom-0">
              <li className={`list-group-item border-bottom${this.props.theme}`}>
                <div className="input-with-icon w-full">
                  <input
										type="text"
										onChange={ this.handleSearchChange }
										className={`form-control${this.props.theme} input-smm${this.props.theme}`}
										placeholder={ translations.search[selectedLanguage] }
									/>
                  <span className="icon icon-magnifying-glass" />
                </div>
              </li>
            </ul>
            <div className="table-responsive">            
			  <table className={`table-fixed table table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}>
                <thead>
                  <tr>
                    <th style={{width: '60%'}}>{translations.agents[selectedLanguage]}</th>
                    <th className="text-right" style={{width: '40%'}}>{translations.state[selectedLanguage]}</th>
                  </tr>
                </thead>
                <tbody style={{ maxHeight: '310px', overflow: 'auto' }}>
                  {this.renderList(agents, 'agents', false)}
                  {/* {this.renderList(agents, 'agents', false, false)} */}
									{agents.length == 0 && <tr>
										{!agentsLoadComplete && <td><Loader width="20px" height="20px" /></td>}
										{agentsLoadComplete && <td>{translations.noAgentsInService[selectedLanguage]}</td>}
									</tr>}
                </tbody>
              </table>
            </div>
						<div className="table-responsive">
              <table className={`table-fixed table table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}>
                <thead>
                  <tr>
                    <th style={{width: '60%'}}>{translations.supervisors[selectedLanguage]}</th>
                    <th className="text-right" style={{width: '40%'}}>{translations.state[selectedLanguage]}</th>
                  </tr>
                </thead>
                <tbody style={{ maxHeight: '310px', overflow: 'auto' }}>
									{this.renderList(agents, 'agents', true)}
									{/* {this.renderList(agents, 'agents', false, true)} */}
									{/* {supervisors.length == 0 && <tr>
										<td>{translations.loading[selectedLanguage]}</td>
									</tr>} */}
                </tbody>
              </table>
            </div>
          </ul>
        </Collapse>
      </div>
	  );
	}
}

function mapStateToProps  (state) {
    return {
				agents: state.agentsAndSupervisors.agents,
				agentsLoadComplete: state.agentsAndSupervisors.agentsLoadComplete,
				supervisors: state.agentsAndSupervisors.supervisors,
				agentInfo: state.agentInfo,
				translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
				darkMode: state.common.darkMode,
				theme: state.common.theme,
    };
}

const mapDispatchToProps = {
	doCall
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentPanel);



// WEBPACK FOOTER //
// ./src/agent/agent-panel.js